import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from '../global-service.service';

@Component({
  selector: 'app-pros',
  templateUrl: './pros.component.html',
  styleUrls: ['./pros.component.css']
})
export class ProsComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.385;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/homepage/pros.component.ts